import { stringDateFormatting } from 'utils/dateFormatter';
import html2pdf from 'html2pdf.js';
import axios from '../../../node_modules/axios/index';
import { REACT_APP_BACKEND_URL } from 'constant/constants';
import { createRoot } from 'react-dom/client';
import InvoicePDF from 'components/InvoicePDF';
import { authPostRequest } from 'Api/api';
import { getStoreLogoPreviewUrl } from 'pages/storePages/storeUtils';

export const sendInvoiceViaEmail = async (pdf, formData, token) => {
  const sendInvoiceRes =
    pdf &&
    axios
      .post(REACT_APP_BACKEND_URL + '/api/sendInvoiceEmail', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })
      .then((res) => {
        console.debug('res', res);
        return res.data;
      });
  return sendInvoiceRes;
};

export const downloadPDF = async (pdfFileName, data, pdfComponentRef) => {
  const options = {
    margin: [10, 10, 20, 10],
    filename: pdfFileName,
    html2canvas: {
      scale: 2,
      allowTaint: true,
      useCORS: true,
      letterRendering: true,
      logging: true
    },
    jsPDF: { unit: 'mm', format: [297, 220] }
  };
  // Create a div element to render the React component
  const container = document.createElement('div');

  // Attach the container to the body

  // Use createRoot to render the React component into the container
  const root = createRoot(container);
  root.render(<InvoicePDF invoiceData={data} ref={pdfComponentRef} />);
  // setTempPDF(<InvoicePDF invoiceData={data} ref={pdfComponentRef} />);

  // Wait for the component to be fully rendered
  await new Promise((resolve) => setTimeout(resolve, 2000));

  container.style.userSelect = 'text';
  const footer = 'Page {pageNumber} | {totalPages}';

  document.querySelectorAll('#pdf-table tr').forEach((row) => {
    row.style.pageBreakInside = 'avoid';
  });

  await html2pdf()
    .from(container)
    .set(options)
    .toPdf()
    .get('pdf')
    .then((pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      const img = new Image();
      img.src = '/logos/TRA-logo.png';
      for (let i = 1; i <= totalPages; i++) {
        // Add header
        pdf.setPage(i);
        // Add footer
        pdf.setFontSize(10);
        pdf.addImage(img, 'png', 93, 280, 30, 10); // x, y, width, height
        pdf.text(
          footer.replace('{pageNumber}', i).replace('{totalPages}', totalPages),
          pdf.internal.pageSize.getWidth() - 25,
          pdf.internal.pageSize.getHeight() - 10
        );
      }
    })
    .output('bloburl')
    .then((blobURL) => {
      const link = document.createElement('a'); // Create a link element
      link.href = blobURL;
      link.target = '_blank'; // Open in new tab
      link.click(); // Simulate a click to open the PDF
    });

  root.unmount();
};

export const downloadSingleQuotePDF = async (
  tableMeta,
  projectID,
  userData,
  storeID,
  pdfComponentRef,
  // setTempPDF,
  setShowLoader
) => {
  try {
    setShowLoader(true);
    // get fresh s3 URL for logo as it may have changes by admin in current login session
    const storeLogoFreshFromS3 = await getStoreLogoPreviewUrl(storeID);
    const invoiceRes = await authPostRequest('getInvoiceDetails', {
      projectId: projectID,
      billTo: userData?.userId,
      userId: userData?.userId,
      roofSectionId: tableMeta.rowData[0]
    });

    window.scrollTo(0, 0);

    if (invoiceRes?.resStatus === 1) {
      const data = invoiceRes?.invoiceResponse[0];
      //true for single quote PDF
      const invoiceData = getFormattedQuoteDataForPDF(data, userData, storeLogoFreshFromS3, true);

      const date = new Date();
      const timeStamp =
        date.getFullYear().toString() + date.getDate().toString() + date.getTime().toString();
      const fileName = 'Estimate_' + timeStamp + '_' + userData?.userId + '.pdf';

      const options = {
        margin: [10, 10, 20, 10],
        filename: fileName,
        html2canvas: {
          scale: 2,
          allowTaint: true,
          useCORS: true,
          letterRendering: true,
          logging: true
        }
      };
      // Create a div element to render the React component
      const container = document.createElement('div');

      // Attach the container to the body
      document.body.appendChild(container);

      // Use createRoot to render the React component into the container
      const root = createRoot(container);
      root.render(<InvoicePDF invoiceData={invoiceData} ref={pdfComponentRef} />);
      // setTempPDF(<InvoicePDF invoiceData={invoiceData} ref={pdfComponentRef} />);

      // Wait for the component to be fully rendered
      await new Promise((resolve) => setTimeout(resolve, 5000));
      container.style.userSelect = 'text';
      const footer = 'Page {pageNumber} | {totalPages}';

      await html2pdf()
        .from(container)
        .set(options)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();

          const img = new Image();
          img.src = '/logos/TRA-logo.png';
          for (let i = 1; i <= totalPages; i++) {
            // Add header
            pdf.setPage(i);
            // Add footer
            pdf.setFontSize(10);
            pdf.addImage(img, 'png', 93, 280, 30, 10); // x, y, width, height
            pdf.text(
              footer.replace('{pageNumber}', i).replace('{totalPages}', totalPages),
              pdf.internal.pageSize.getWidth() - 25,
              pdf.internal.pageSize.getHeight() - 10
            );
          }
        })
        .output('bloburl')
        .then((blobURL) => {
          const link = document.createElement('a'); // Create a link element
          link.href = blobURL;
          link.target = '_blank'; // Open in new tab
          link.click(); // Simulate a click to open the PDF
        });

      root.unmount();
      container.remove();

      setShowLoader(false);
    }
  } catch (err) {
    console.log(err);
    window.scrollTo(0, 0);
    setShowLoader(false);
  }
};

/**
 * This is to get formatted object for invice/estimate pdf
 *
 * @param {object} data invocieData
 * @param {object} userData logged in user data
 * @param {string} storeLogoFreshFromS3 store logo URL from s3
 * @returns formatted object for pdf to render properly estimat/invoice/quote data
 */
export const getFormattedQuoteDataForPDF = (
  data,
  userData,
  storeLogoFreshFromS3,
  isSingleRoofSection = false
) => {
  const total = parseFloat(data.invoiceTotal).toFixed(2);
  return {
    store: {
      name: data?.storeName,
      contact: data?.contactName,
      phone: data?.storePhone,
      address: data?.storeAddress,
      email: data?.storeEmail,
      logo: storeLogoFreshFromS3
    },
    project: {
      name: data?.projectName,
      description: data?.projectDescription
    },
    invoiceNumber: data.invoiceId || 'N/A',
    createDate: stringDateFormatting(data.invoiceDate) || 'N/A',
    // expirationDate: '28 6 9999',
    billTo: {
      name: userData?.fullName || 'N/A',
      email: userData?.userName || 'N/A'
    },
    items: data?.invoiceDetails?.map((item) => {
      return {
        itemName: item?.itemName,
        material: item?.material,
        seamType: item?.seamType,
        quantity: Math.ceil(item?.quantity),
        unitPrice: parseFloat(item?.unitPrice)?.toFixed(2),
        totalPrice: parseFloat(item?.bracketsPrice)?.toFixed(2),
        systemComponents: item?.systemComponents || []
      };
    }),
    salesTotal: isSingleRoofSection ? total : data?.projectPrice?.toFixed(2),
    handlingFee: isSingleRoofSection ? null : data?.handlingFee,
    handlingAmount: isSingleRoofSection ? null : data?.handlingFeeAmount?.toFixed(2),
    taxTotal: 0.0,
    total: isSingleRoofSection ? total : data?.projectTotalPrice?.toFixed(2)
  };
};
